export default __webpack_public_path__ + "static/media/gubee-logo-disabled.81366cbd.svg";